import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import MovieServices from '../../services/externalServices/TicketServices/moviesServices';
import { FiArchive, FiEdit, FiTrash2, FiPlus, FiFilm } from 'react-icons/fi';


function Movies() {
    const navigate = useNavigate();
    const [movies, setMovies] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteMovieId, setDeleteMovieId] = useState(null);
    const [statusMessage, setStatusMessage] = useState(null);
    const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
    const [activeTab, setActiveTab] = useState('nowShowing'); // Default to 'nowShowing' tab



    useEffect(() => {
        if (statusMessage) {
            const timer = setTimeout(() => {
                setStatusMessage(null);
            }, 5000); // 5 seconds
            return () => clearTimeout(timer);
        }
    }, [statusMessage]);

    useEffect(() => {
        const fetchMovies = async () => {
            try {
                // Pass theatreName only if the user is a ticket-admin
                const isTicketAdmin = role === 'ticket-admin';
                console.log('isTicketAdmin', isTicketAdmin);
                const theatreName = accessList?.[0]; // assuming accessList contains theatre name

                // const cleanTheatreName = (theatreName || '').replace(/\?$/, '').trim();

                // const movies = await MovieServices.getMovies(isTicketAdmin ? theatreName : '');
                const movies = await MovieServices.getAllMoviesWithSchedules(isTicketAdmin ? theatreName : '');

                console.log('Movies in the screen with show schedule for the new one', movies);
                setMovies(movies);
            } catch (err) {
                console.error("Error fetching movies:", err);
            }
        };
        fetchMovies();
    }, []);


    const AddMovies = () => {
        navigate('/addMovies')
    }


    // const handleView = (movie) => navigate(`/movieDetails/${movie._id}`, { state: { movie } });
    // const handleEdit = (movie) => console.log("Edit", movie);
    const handleEdit = (movie) => {
        navigate('/editMovies', { state: { movie } });
    };
    // const handleDelete = (id) => console.log("Delete", id);




    const confirmDeleteMovie = async () => {
        try {
            const response = await MovieServices.deleteMovie(deleteMovieId);
            const message = response?.message || '';
            setStatusMessage({ type: 'success', text: message });

            if (message === 'Movie deleted successfully') {
                setMovies((prev) => prev.filter((m) => m._id !== deleteMovieId));
            }
        } catch (error) {
            const errorMsg = error?.response?.message || 'Failed to delete movie.';
            setStatusMessage({ type: 'error', text: errorMsg });
        } finally {
            setShowDeleteModal(false);
            setDeleteMovieId(null);
        }
    };

    const handleDelete = (id) => {
        setDeleteMovieId(id);
        setShowDeleteModal(true);
    };






    const handleArchive = async (id) => {
        const movie = movies.find(m => m._id === id);
        if (!movie) return;

        const action = movie.isArchived ? "unarchive" : "archive";
        const confirmMessage = `Are you sure you want to ${action} this movie?`;

        if (!window.confirm(confirmMessage)) return;

        try {
            const response = await MovieServices.updateMovie(id, {
                isArchived: !movie.isArchived
            });

            setStatusMessage({
                type: 'success',
                text: `✅ Movie ${action}d successfully!`
            });

            // Update the movie in state instead of filtering it out
            setMovies(prev => prev.map(m =>
                m._id === id ? { ...m, isArchived: !m.isArchived } : m
            ));
        } catch (err) {
            console.error(`Failed to ${action} movie`, err);
            setStatusMessage({
                type: 'error',
                text: `❌ Failed to ${action} movie.`
            });
        }
    };


    // MovieCard component (extracted for better readability)
    const MovieCard = ({ movie, handleEdit, handleDelete, handleArchive, activeTab }) => (
        <div className="flex flex-col h-full bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-lg transition-shadow duration-300">
            <div className="relative h-64 w-full overflow-hidden">
                <img
                    src={movie.imageUrl}
                    alt={movie.name}
                    className="w-full h-full object-cover"
                />
                {movie.isArchived && (
                    <div className="absolute top-2 -right-3 text-xs font-bold text-white px-3 py-1 rounded-full shadow-md bg-yellow-400">
                        Archived
                    </div>
                )}
                {/* {!movie.isReadyForBooking && !movie.isArchived && ( */}

                {!isNowShowing(movie) && !isArchived(movie) && (

                    <div className="absolute top-2 -right-3 text-xs font-bold text-white px-3 py-1 rounded-full shadow-md bg-[#dd0426]">
                        Coming Soon
                    </div>
                )}
                <div className="absolute bottom-0 w-full p-4 bg-gradient-to-t from-black/80 to-transparent text-white">
                    <h3 className="text-xl font-semibold truncate">{movie.name}</h3>
                    <div className="flex items-center justify-between text-sm mt-1">
                        <span>{movie.duration} mins</span>
                        <div className="flex items-center gap-1">
                            <span className="text-yellow-400">★</span>
                            <span>{movie.imdbRating}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex-grow p-4">
                <div className="flex flex-wrap gap-2">
                    {movie.movieLanguages.map((lang, i) => (
                        <span key={i} className="px-2 py-1 bg-blue-100 text-gray-800 text-xs rounded-full font-medium">
                            {lang}
                        </span>
                    ))}
                </div>
            </div>

            <div className="p-4 border-t border-gray-200 bg-white">
                <div className="flex justify-between">
                    <button
                        onClick={() => handleEdit(movie)}
                        className="p-2 text-blue-600 hover:bg-blue-100 rounded-full transition-colors"
                        title="Edit"
                    >
                        <FiEdit size={18} />
                    </button>
                    <button
                        onClick={() => handleDelete(movie._id)}
                        className="p-2 text-red-600 hover:bg-red-100 rounded-full transition-colors"
                        title="Delete"
                    >
                        <FiTrash2 size={18} />
                    </button>



                    {/* {activeTab !== 'comingSoon' && (
                        <button
                            onClick={() => handleArchive(movie._id)}
                            className={`p-2 rounded-full transition-colors ${movie.isArchived
                                    ? "text-green-600 hover:bg-green-100"
                                    : "text-yellow-600 hover:bg-yellow-100"
                                }`}
                            title={movie.isArchived ? "Unarchive" : "Archive"}
                        >
                            <FiArchive size={18} />
                        </button>
                    )} */}

                    {/* <button
                        onClick={() => handleArchive(movie._id)}
                        className={`p-2 rounded-full transition-colors ${movie.isArchived
                            ? "text-green-600 hover:bg-green-100"
                            : "text-yellow-600 hover:bg-yellow-100"
                            }`}
                        title={movie.isArchived ? "Unarchive" : "Archive"}
                    >
                        <FiArchive size={18} />
                    </button> */}
                </div>
            </div>
        </div>
    );



    // For ReadyForBooking in the schedule 


    const isNowShowing = (movie) => {
        if (movie.isArchived) return false;
        return movie.showSchedules?.some(schedule =>
            schedule.theatreDetails?.some(theatre =>
                theatre.isReadyForBooking && !theatre.isArchived
            )
        );
    };

    // const isComingSoon = (movie) => {
    //     if (movie.isArchived) return false;
    //     const hasNoSchedules = !movie.showSchedules || movie.showSchedules.length === 0;

    //     const allNotReadyOrArchived = movie.showSchedules?.every(schedule =>
    //         schedule.theatreDetails?.every(theatre =>
    //             !theatre.isReadyForBooking || !theatre.isArchived
    //         )
    //     );

    //     return hasNoSchedules || allNotReadyOrArchived;
    // };


    const isComingSoon = (movie) => {
        if (isArchived(movie)) return false;
        const hasNoSchedules = !movie.showSchedules || movie.showSchedules.length === 0;
        const allNotReadyOrArchived = movie.showSchedules?.every(schedule =>
          schedule.theatreDetails?.every(theatre =>
            !theatre.isReadyForBooking || theatre.isArchived
          )
        );
        return hasNoSchedules || allNotReadyOrArchived;
      };

    // const isArchived = (movie) => movie.isArchived;

    const isArchived = (movie) => {
        return movie.showSchedules?.length > 0 &&
          movie.showSchedules.every(schedule =>
            schedule.theatreDetails?.length > 0 &&
            schedule.theatreDetails.every(theatre => theatre.isArchived)
          );
      };



    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-purple-50 pb-12">
            <div className="container mx-auto px-4 py-8">
                <div className="flex items-center justify-between mb-12">
                    <h1 className="text-3xl font-bold text-gray-900">Movie Management</h1>
                    <button
                        onClick={AddMovies}
                        className="flex items-center gap-2 bg-black hover:bg-gray-700 text-white px-4 py-2 transition-all shadow-md hover:scale-105"
                    >
                        <FiPlus className="text-lg" />
                        <span>Add Movie</span>
                    </button>
                </div>

                {/* Status Message */}
                {statusMessage && (
                    // <div className={`fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-lg shadow-xl z-50 
                    //     ${statusMessage.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                    //     {statusMessage.text}


                    // </div>


                    <div className={`fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-lg shadow-xl z-[9999] 
    ${statusMessage.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {statusMessage.text}
                    </div>
                )}



                {/* Delete Modal */}
                {showDeleteModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-xl p-6 w-96 shadow-lg text-center">
                            <h2 className="text-xl font-semibold text-gray-900">Are you sure?</h2>
                            <p className="text-gray-600 mt-2">This action cannot be undone.</p>
                            <div className="flex justify-center gap-4 mt-6">
                                <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300">Cancel</button>
                                <button onClick={confirmDeleteMovie} className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700">Confirm</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Tabs */}
                <div className="mb-8 border-b border-gray-200">
                    <div className="flex space-x-8">
                        <button
                            onClick={() => setActiveTab('nowShowing')}
                            className={`py-2 px-1 font-medium text-sm border-b-2 ${activeTab === 'nowShowing' ? 'border-black text-black' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                        >
                            Now Showing
                        </button>
                        <button
                            onClick={() => setActiveTab('comingSoon')}
                            className={`py-2 px-1 font-medium text-sm border-b-2 ${activeTab === 'comingSoon' ? 'border-black text-black' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                        >
                            Coming Soon
                        </button>
                        <button
                            onClick={() => setActiveTab('archived')}
                            className={`py-2 px-1 font-medium text-sm border-b-2 ${activeTab === 'archived' ? 'border-black text-black' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                        >
                            Archived
                        </button>
                    </div>
                </div>

                {/* Movie Grids */}
                {/* {activeTab === 'nowShowing' && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {movies.filter(movie => movie.isReadyForBooking && !movie.isArchived).length > 0 ? (
                            movies.filter(movie => movie.isReadyForBooking && !movie.isArchived).map((movie) => (
                                <MovieCard key={movie._id} movie={movie} handleEdit={handleEdit} handleDelete={handleDelete} handleArchive={handleArchive} />
                            ))
                        ) : (
                            <div className="col-span-full flex flex-col items-center justify-center h-64">
                                <FiFilm className="text-6xl text-gray-500 mb-4" />
                                <p className="text-2xl text-gray-400 font-medium">No movies showing now</p>
                            </div>
                        )}
                    </div>
                )} */}



                {activeTab === 'nowShowing' && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {movies.filter(isNowShowing).length > 0 ? (
                            movies.filter(isNowShowing).map((movie) => (
                                <MovieCard key={movie._id} movie={movie} handleEdit={handleEdit} handleDelete={handleDelete} handleArchive={handleArchive} activeTab={activeTab} />
                            ))
                        ) : (
                            <div className="col-span-full flex flex-col items-center justify-center h-64">
                                <FiFilm className="text-6xl text-gray-500 mb-4" />
                                <p className="text-2xl text-gray-400 font-medium">No movies showing now</p>
                            </div>
                        )}
                    </div>
                )}


                {/* {activeTab === 'comingSoon' && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {movies.filter(movie => !movie.isReadyForBooking && !movie.isArchived).length > 0 ? (
                            movies.filter(movie => !movie.isReadyForBooking && !movie.isArchived).map((movie) => (
                                <MovieCard key={movie._id} movie={movie} handleEdit={handleEdit} handleDelete={handleDelete} handleArchive={handleArchive} />
                            ))
                        ) : (
                            <div className="col-span-full flex flex-col items-center justify-center h-64">
                                <FiFilm className="text-6xl text-gray-500 mb-4" />
                                <p className="text-2xl text-gray-400 font-medium">No upcoming movies</p>
                            </div>
                        )}
                    </div>
                )} */}

                {/* {activeTab === 'archived' && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {movies.filter(movie => movie.isArchived).length > 0 ? (
                            movies.filter(movie => movie.isArchived).map((movie) => (
                                <MovieCard key={movie._id} movie={movie} handleEdit={handleEdit} handleDelete={handleDelete} handleArchive={handleArchive} />
                            ))
                        ) : (
                            <div className="col-span-full flex flex-col items-center justify-center h-64">
                                <FiFilm className="text-6xl text-gray-500 mb-4" />
                                <p className="text-2xl text-gray-400 font-medium">No archived movies</p>
                            </div>
                        )}
                    </div>
                )} */}






                {activeTab === 'comingSoon' && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {movies.filter(isComingSoon).length > 0 ? (
                            movies.filter(isComingSoon).map((movie) => (
                                <MovieCard key={movie._id} movie={movie} handleEdit={handleEdit} handleDelete={handleDelete} handleArchive={handleArchive} activeTab={activeTab} />
                            ))
                        ) : (
                            <div className="col-span-full flex flex-col items-center justify-center h-64">
                                <FiFilm className="text-6xl text-gray-500 mb-4" />
                                <p className="text-2xl text-gray-400 font-medium">No upcoming movies</p>
                            </div>
                        )}
                    </div>
                )}


                {activeTab === 'archived' && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {movies.filter(isArchived).length > 0 ? (
                            movies.filter(isArchived).map((movie) => (
                                <MovieCard key={movie._id} movie={movie} handleEdit={handleEdit} handleDelete={handleDelete} handleArchive={handleArchive} activeTab={activeTab} />
                            ))
                        ) : (
                            <div className="col-span-full flex flex-col items-center justify-center h-64">
                                <FiFilm className="text-6xl text-gray-500 mb-4" />
                                <p className="text-2xl text-gray-400 font-medium">No archived movies</p>
                            </div>
                        )}
                    </div>
                )}

            </div>
        </div>
    );




}





export default Movies

